import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';

const sectionContactForm = () => {
  const sections = document.querySelectorAll('.js-contact-form-anim');
  const sectionsElements = document.querySelectorAll('.c-contact-form,.c-form');

  if (sections.length !== 0) {
    sections.forEach(section => {
      const bg = Snap(section);
      if (bg) {
        createTriangle(bg, 180, -50, 1400, 80, 20);
        createTriangle(bg, 90, -40, 1500, 550, 20);
        createTriangle(bg, 70, 0, 1800, 650, 20);
        createTriangle(bg, 220, -130, 1780, 300, 60);
      }
    });
  }
  if (sectionsElements.length !== 0) {
    sectionsElements.forEach(el => {
      if (el.querySelector('.js-accept')) {
        el.querySelector('.js-accept').addEventListener('change', () => {
          el.querySelector('.js-to-accept').checked = el.querySelector(
            '.js-accept',
          ).checked;
        });
      }
    });
  }
};

export default sectionContactForm;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-contact-form.js